import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';
import {
  Accordion, Button, Divider, Form, Header,
  Icon, Loader, Table, Segment, Statistic
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { Route } from 'react-router-dom';
import ReactTable from "react-table";
import feathersConnect from './../../../providers/feathersConnect';
import ATable from '../../auto/ATable';
import MaskedInput from 'react-text-mask';
import numeral from 'numeral';
import moment from 'moment';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const numberMask = createNumberMask({
  prefix: '',
  allowDecimal: true,
  requireDecimal: true,
  allowNegative: true
});

const PAGE_RANGE = 5;

const INITIAL_STATE = {
  eeconomico: {
    loading: false,
    data: null,
    error: null
  },
  prevEeconomico: null,
  espatrimonial: {
    id: null,
    cajaBancos: 0,
    creditosAC: 0,
    bienesCambioAC: 0,
    creditosANC: 0,
    bienesCambioANC: 0,
    bienesUsoANC: 0,
    deudasPC: 0,
    deudasPNC: 0,
    patrimonioNeto: 0
  },
  estadoEvolucionPatrimonio: [],
  estadoResultados: {
    id: null,
    ingresosVentas: 0,
    costoVentas: 0,
    egresosComercializacion: 0,
    egresosAdministracion: 0,
    egresosFinancieros: 0,
    egresosFiscales: 0,
    egresosGenerales: 0,
    ingresosIndirectamenteAtribuidos: 0,
    gastosIndirectamenteAtribuidos: 0,
    ingresosExtraordinarios: 0,
    resultadoGestionAsociados: 0,
    resultadoGestionNoAsociados: 0,
    resultadoOperacionesAjenas: 0
  },
  propuestaAplicacionDistribucion: {
    id: null,
    excedenteEjercicio: 0,
    resultadoGestionNoAsociados: 0,
    resultadoOperacionesAjenas: 0,
    reservaLegal: 0,
    reservaArt42: 0,
    fondoEstimulo: 0,
    fondoEducacionCapacitacion: 0,
    interesesAPagar: 0,
    excedentesCuotaSocial: 0
  }
};

class CoopEEconomicoDetalleView extends Component {

  constructor (props) {
    super(props);

    this.state = INITIAL_STATE;

    this.EEconomicoService = this.props.feathers.service('api/eeconomicos');
    this.ESPatrimonialService = this.props.feathers.service('api/estado-situacion-patrimonial');
    this.EVPatrimonoService = this.props.feathers.service('api/estado-evolucion-patrimonio');
    this.EstadoResultadosService = this.props.feathers.service('api/estado-resultados');
    this.PropuestaAplicacionDistribucionService = this.props.feathers.service('api/propuesta-aplicacion-distribucion');
    this.InversionService = this.props.feathers.service('api/inversiones');
    this.CursoService = this.props.feathers.service('api/cursos');
    this.VolumenVentaService = this.props.feathers.service('api/volumenes-venta');
    this.PersonalService = this.props.feathers.service('api/personal');
  }

  fetchEEconomico () {
    this.setState({
      ...INITIAL_STATE,
      eeconomico: {
        ...INITIAL_STATE.eeconomico,
        loading: true
      }
    });

    this.EEconomicoService.get(this.props.match.params.eeconomico)
      .then(response => {
        console.log(response);
        this.setState({
          eeconomico: {
            ...this.state.eeconomico,
            loading: false,
            data: response.eeconomico
          },
          espatrimonial: {
            ...response.eeconomico.estadoSituacionPatrimonial
          },
          estadoEvolucionPatrimonio: response.eeconomico.estadoEvolucionPatrimonio.matrix.map(result => {
            let formatted = {};

            Object.keys(result).forEach(key => {
              if (key !== 'rubro') {
                formatted[key] = numeral(result[key]).format('0,0.00');
              }
            });

            formatted.rubro = result.rubro;

            return formatted;
          }),
          estadoResultados: {
            ...response.eeconomico.estadoResultados
          },
          propuestaAplicacionDistribucion: {
            ...response.eeconomico.propuestaAplicacionDistribucion
          },
          prevEeconomico: response.prevEeconomico
        });
      })
      .catch(error => {
        this.setState({
          eeconomico: {
            ...this.state.eeconomico,
            loading: false,
            error: error
          }
        });
      });
  }

  espatrimonialInputHandler (name) {
    return (e, input) => {
      this.setState({
        espatrimonial: {
          ...this.state.espatrimonial,
          [name]: e.target.value
        }
      });
    };
  }

  estadoResultadosInputHandler (name) {
    return (e, input) => {
      this.setState({
        estadoResultados: {
          ...this.state.estadoResultados,
          [name]: e.target.value
        }
      });
    };
  }

  propuestaAplicacionDistribucionInputHandler (name) {
    return (e, input) => {
      this.setState({
        propuestaAplicacionDistribucion: {
          ...this.state.propuestaAplicacionDistribucion,
          [name]: e.target.value
        }
      });
    };
  }

  submitESPatrimonial () {
    let { espatrimonial } = this.state;
    let formatedValues = {};

    Object.keys(espatrimonial).forEach(key => {
      if (key !== 'id' && key !== 'createdAt' && key !== 'updatedAt') {
        formatedValues[key] = numeral(espatrimonial[key]).value();
      }
    });

    this.ESPatrimonialService.patch(espatrimonial.id, formatedValues)
      .then(response => {
        this.fetchEEconomico();
      })
      .catch(console.log);
  }

  submitEVPatrimonio () {
    let {
      eeconomico,
      estadoEvolucionPatrimonio
    } = this.state;

    this.EVPatrimonoService.patch(eeconomico.data.estadoEvolucionPatrimonio.id, {
      ...eeconomico.estadoEvolucionPatrimonio,
      matrix: estadoEvolucionPatrimonio
    })
      .then(response => {
        this.fetchEEconomico();
      })
      .catch(console.log);
  }

  submitEstadoResultados () {
    let {
      estadoResultados
    } = this.state;
    let formatedValues = {};

    Object.keys(estadoResultados).forEach(key => {
      if (key !== 'id' && key !== 'createdAt' && key !== 'updatedAt') {
        formatedValues[key] = numeral(estadoResultados[key]).value();
      }
    });

    this.EstadoResultadosService.patch(estadoResultados.id, formatedValues)
      .then(response => {
        this.fetchEEconomico();
      })
      .catch(console.log);
  }

  submitPropuestaAplicacionDistribucion () {
    let {
      propuestaAplicacionDistribucion
    } = this.state;
    let formatedValues = {};

    Object.keys(propuestaAplicacionDistribucion).forEach(key => {
      if (key !== 'id' && key !== 'createdAt' && key !== 'updatedAt') {
        formatedValues[key] = numeral(propuestaAplicacionDistribucion[key]).value();
      }
    });

    this.PropuestaAplicacionDistribucionService.patch(propuestaAplicacionDistribucion.id, formatedValues)
      .then(response => {
        this.fetchEEconomico();
      })
      .catch(console.log);
  }

  componentDidMount () {
    this.fetchEEconomico();
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.match.params.eeconomico !== prevProps.match.params.eeconomico) {
      this.fetchEEconomico();
    }
  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  renderEditable = (type = 'number') => (cellInfo) => {
    let { estadoEvolucionPatrimonio } = this.state;

    return (
      <div
        style={{ backgroundColor: "#fafafa", textAlign: (type === 'number') ? 'right' : 'left' }}
        contentEditable
        suppressContentEditableWarning
        onBlur={e => {
          if (type === 'number') {
            const data = [...estadoEvolucionPatrimonio];
            let value = e.target.innerHTML;

            data[cellInfo.index][cellInfo.column.id] =
              numeral(value) ?
                numeral(value).format('0,0.00') : '$0.00';

            this.setState({ data });
          } else {
            const data = [...estadoEvolucionPatrimonio];
            let value = e.target.innerHTML;
            data[cellInfo.index][cellInfo.column.id] = value;
            this.setState({ data });
          }
        }}
        dangerouslySetInnerHTML={{
          __html: estadoEvolucionPatrimonio[cellInfo.index][cellInfo.column.id]
        }} />
    );
  }

  render () {
    let {
      eeconomico,
      prevEeconomico,
      espatrimonial,
      estadoEvolucionPatrimonio,
      estadoResultados,
      propuestaAplicacionDistribucion
    } = this.state;

    if (eeconomico.loading && !eeconomico.data) {
      return <Loader active inline content="Cargando..." />;
    }

    return (
      <Segment style={{ padding: 0 }} loading={eeconomico.loading}>
        <Accordion fluid styled>
          <Accordion.Title>
            <Icon name="dropdown" />
            Estado de Situacion Patrimonial
          </Accordion.Title>
          <Accordion.Content>
            <EstadoSituacionPatrimonial
              eeconomico={this.props.match.params.eeconomico}
              prevEeconomico={prevEeconomico}
              loading={eeconomico.loading}
              InversionService={this.InversionService}
              CursoService={this.CursoService}
              espatrimonial={espatrimonial}
              createInputHandler={this.espatrimonialInputHandler.bind(this)}
              submitValues={this.submitESPatrimonial.bind(this)} />
          </Accordion.Content>
          <Accordion.Title>
            <Icon name="dropdown" />
            Estado de Evolucion del Patrimonio Neto
          </Accordion.Title>
          <Accordion.Content>
            <EstadoEvolucionPatrimonioNeto
              loading={eeconomico.loading} data={estadoEvolucionPatrimonio}
              eeconomico={eeconomico.data} prevEeconomico={prevEeconomico}
              renderEditable={this.renderEditable.bind(this)} submitValues={this.submitEVPatrimonio.bind(this)} />
          </Accordion.Content>
          <Accordion.Title>
            <Icon name="dropdown" />
            Estado de Resultados
          </Accordion.Title>
          <Accordion.Content>
            <EstadoResultados
              eeconomico={this.props.match.params.eeconomico}
              prevEeconomico={prevEeconomico}
              loading={eeconomico.loading}
              estadoResultados={estadoResultados}
              createInputHandler={this.estadoResultadosInputHandler.bind(this)}
              submitValues={this.submitEstadoResultados.bind(this)}
              VolumenVentaService={this.VolumenVentaService} PersonalService={this.PersonalService} />
          </Accordion.Content>
          <Accordion.Title>
            <Icon name="dropdown" />
            Propuesta de Aplicacion y Distribucion de Excedentes
          </Accordion.Title>
          <Accordion.Content>
            <PropuestaAplicacionDistribucionExcedentes
              eeconomico={eeconomico.data}
              prevEeconomico={prevEeconomico}
              propuestaAplicacionDistribucion={propuestaAplicacionDistribucion}
              loading={eeconomico.loading}
              createInputHandler={this.propuestaAplicacionDistribucionInputHandler.bind(this)}
              submitValues={this.submitPropuestaAplicacionDistribucion.bind(this)} />
          </Accordion.Content>
        </Accordion>
      </Segment>
    );
  }
}

export default feathersConnect(
  connect(
    CoopEEconomicoDetalleView.mapStateToProps,
    CoopEEconomicoDetalleView.mapDispatchToProps
  )(CoopEEconomicoDetalleView)
);

function sumStringsToFloats (...stringValues) {
  return stringValues.reduce((prev, curr) => prev + numeral(curr).value(), 0);
}

const EstadoSituacionPatrimonial = ({ loading, prevEeconomico, InversionService, CursoService, espatrimonial, createInputHandler, submitValues }) => (
  <div>
    <Header as="h5" content="Activo" />
    <Header as="h5" content="Activo Corriente" style={{ marginTop: 0 }} dividing />
    <Table basic="very" compact celled columns={3}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell />
          <Table.HeaderCell>Actual</Table.HeaderCell>
          <Table.HeaderCell>Anterior</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Caja y Bancos</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" size="mini" fluid
              children={
                <MaskedInput mask={numberMask} value={espatrimonial.cajaBancos} onChange={createInputHandler('cajaBancos')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoSituacionPatrimonial.cajaBancos).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Creditos</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" size="mini" fluid
              children={
                <MaskedInput mask={numberMask} value={espatrimonial.creditosAC} onChange={createInputHandler('creditosAC')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoSituacionPatrimonial.creditosAC).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Bienes de Cambio</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" size="mini" fluid
              children={
                <MaskedInput mask={numberMask} value={espatrimonial.bienesCambioAC} onChange={createInputHandler('bienesCambioAC')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoSituacionPatrimonial.bienesCambioAC).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>Total Activo Corriente</Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(sumStringsToFloats(espatrimonial.cajaBancos, espatrimonial.creditosAC, espatrimonial.bienesCambioAC)).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(
                  sumStringsToFloats(
                    prevEeconomico.estadoSituacionPatrimonial.cajaBancos,
                    prevEeconomico.estadoSituacionPatrimonial.creditosAC,
                    prevEeconomico.estadoSituacionPatrimonial.bienesCambioAC
                  )
                ).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
      </Table.Body>
    </Table>
    <Header as="h5" content="Activo No Corriente" style={{ marginTop: 0 }} dividing />
    <Table basic="very" compact celled columns={3}>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Creditos</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" size="mini" fluid
              children={
                <MaskedInput mask={numberMask} value={espatrimonial.creditosANC} onChange={createInputHandler('creditosANC')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(sumStringsToFloats(prevEeconomico.estadoSituacionPatrimonial.creditosANC)).format('0,0.00'): '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Bienes de Cambio</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" size="mini" fluid
              children={
                <MaskedInput mask={numberMask} value={espatrimonial.bienesCambioANC} onChange={createInputHandler('bienesCambioANC')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(sumStringsToFloats(prevEeconomico.estadoSituacionPatrimonial.bienesCambioANC)).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Bienes de Uso</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" size="mini" fluid
              children={
                <MaskedInput mask={numberMask} value={espatrimonial.bienesUsoANC} onChange={createInputHandler('bienesUsoANC')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(sumStringsToFloats(prevEeconomico.estadoSituacionPatrimonial.bienesUsoANC)).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>Total Activo No Corriente</Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(sumStringsToFloats(espatrimonial.creditosANC, espatrimonial.bienesCambioANC, espatrimonial.bienesUsoANC)).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(
                  sumStringsToFloats(
                    prevEeconomico.estadoSituacionPatrimonial.creditosANC,
                    prevEeconomico.estadoSituacionPatrimonial.bienesCambioANC,
                    prevEeconomico.estadoSituacionPatrimonial.bienesUsoANC
                  )
                ).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>Total Activo</Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(
                sumStringsToFloats(
                  sumStringsToFloats(espatrimonial.cajaBancos, espatrimonial.creditosAC, espatrimonial.bienesCambioAC),
                  sumStringsToFloats(espatrimonial.creditosANC, espatrimonial.bienesCambioANC, espatrimonial.bienesUsoANC)
                )
              ).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(
                  sumStringsToFloats(
                    sumStringsToFloats(
                      prevEeconomico.estadoSituacionPatrimonial.cajaBancos,
                      prevEeconomico.estadoSituacionPatrimonial.creditosAC,
                      prevEeconomico.estadoSituacionPatrimonial.bienesCambioAC
                    ),
                    sumStringsToFloats(
                      prevEeconomico.estadoSituacionPatrimonial.creditosANC,
                      prevEeconomico.estadoSituacionPatrimonial.bienesCambioANC,
                      prevEeconomico.estadoSituacionPatrimonial.bienesUsoANC
                    )
                  )
                ).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
      </Table.Body>
    </Table>
    <Segment clearing vertical>
      <Button floated="right" disabled={loading} content={loading ? 'Guardando...' : 'Guardar'} positive onClick={submitValues} />
    </Segment>
    <Header as="h5" content="Inversiones" dividing />
    <ATable
      pageRange={PAGE_RANGE}
      headers={{
        'Concepto': ['concepto'],
        'Monto': ['monto']
      }}
      service={InversionService}
      options={{
        serviceParams: {
          EstadoSituacionPatrimonialId: espatrimonial.id
        }
      }}
      form={{
        fields: [
          ['!Concepto', 'concepto', 'input', 5],
          ['!Monto', 'monto', 'number', 5]
        ],
        service: InversionService,
        options: {
          serviceParams: {
            EstadoSituacionPatrimonialId: espatrimonial.id
          }
        }
      }} />
    <Header as="h5" content="Pasivo" />
    <Header as="h5" content="Pasivo Corriente" style={{ marginTop: 0 }} dividing />
    <Table basic="very" celled columns={3}>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Deudas</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={espatrimonial.deudasPC} onChange={createInputHandler('deudasPC')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoSituacionPatrimonial.deudasPC).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
    <Header as="h5" content="Pasivo No Corriente" style={{ marginTop: 0 }} dividing />
    <Table basic="very" compact celled columns={3}>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Deudas</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={espatrimonial.deudasPNC} onChange={createInputHandler('deudasPNC')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoSituacionPatrimonial.deudasPNC).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>Total Pasivo</Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(sumStringsToFloats(espatrimonial.deudasPC, espatrimonial.deudasPNC)).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(
                  sumStringsToFloats(
                    prevEeconomico.estadoSituacionPatrimonial.deudasPC,
                    prevEeconomico.estadoSituacionPatrimonial.deudasPNC
                  )
                ).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>Patrimonio Neto</Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(
                (
                  parseFloat(
                    sumStringsToFloats(
                      sumStringsToFloats(espatrimonial.cajaBancos, espatrimonial.creditosAC, espatrimonial.bienesCambioAC),
                      sumStringsToFloats(espatrimonial.creditosANC, espatrimonial.bienesCambioANC, espatrimonial.bienesUsoANC)
                    )
                  ) - parseFloat(sumStringsToFloats(espatrimonial.deudasPC, espatrimonial.deudasPNC))
                ).toFixed(2)
              ).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(
                  (
                    parseFloat(
                      sumStringsToFloats(
                        sumStringsToFloats(
                          prevEeconomico.estadoSituacionPatrimonial.cajaBancos,
                          prevEeconomico.estadoSituacionPatrimonial.creditosAC,
                          prevEeconomico.estadoSituacionPatrimonial.bienesCambioAC
                        ),
                        sumStringsToFloats(
                          prevEeconomico.estadoSituacionPatrimonial.creditosANC,
                          prevEeconomico.estadoSituacionPatrimonial.bienesCambioANC,
                          prevEeconomico.estadoSituacionPatrimonial.bienesUsoANC
                        )
                      )
                    ) - parseFloat(sumStringsToFloats(prevEeconomico.estadoSituacionPatrimonial.deudasPC, prevEeconomico.estadoSituacionPatrimonial.deudasPNC))
                  ).toFixed(2)
                ).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
      </Table.Body>
    </Table>
    <Segment clearing vertical>
      <Button floated="right" disabled={loading} content={loading ? 'Guardando...' : 'Guardar'} positive onClick={submitValues} />
    </Segment>
    <Header as="h5" content="Cursos" dividing />
    <ATable
      pageRange={PAGE_RANGE}
      headers={{
        'Concepto': ['concepto'],
        'Monto': ['monto'],
        'Disertante / Asistencia': ['asistencia']
      }}
      service={CursoService}
      options={{
        serviceParams: {
          EstadoSituacionPatrimonialId: espatrimonial.id
        }
      }}
      form={{
        fields: [
          ['!Concepto', 'concepto', 'input', 5],
          ['!Monto', 'monto', 'number', 5],
          ['!Disertante / Asistencia', 'asistencia', 'input', 5]
        ],
        service: CursoService,
        options: {
          serviceParams: {
            EstadoSituacionPatrimonialId: espatrimonial.id
          }
        }
      }} />
  </div>
);

const EstadoEvolucionPatrimonioNeto = ({ loading, eeconomico, prevEeconomico, data, renderEditable, submitValues }) => (
  <div>
    <ReactTable
      data={data}
      showPagination={false}
      columns={[
        {
          Header: 'Rubros',
          accessor: 'rubro',
          Cell: renderEditable('regular')
        },
        {
          Header: 'Aporte de los propietarios',
          columns: [
            {
              Header: 'Capital Social',
              accessor: "capitalSocial",
              Cell: renderEditable(),
              getFooterProps: () => ({ style: { textAlign: 'right' }}),
              Footer: (
                <span><strong>
                  {
                    numeral(
                      data.reduce((prev, curr) =>
                        prev + numeral(curr.capitalSocial).value(), 0)
                    ).format('0,0.00')
                  }
                </strong></span>
              )
            },
            {
              Header: 'Ajuste al Capital',
              accessor: "ajusteCapital",
              Cell: renderEditable(),
              getFooterProps: () => ({ style: { textAlign: 'right' } }),
              Footer: (
                <span><strong>
                  {
                    numeral(data.reduce((prev, curr) => prev + numeral(curr.ajusteCapital).value(), 0)).format('0,0.00')
                  }
                </strong></span>
              )
            },
            {
              Header: 'Total',
              accessor: "aporteTotal",
              Cell: (props) => (
                <div style={{ textAlign: 'right' }}><strong>
                  {
                    numeral(
                      numeral(props.row.capitalSocial).value() +
                      numeral(props.row.ajusteCapital).value()
                    ).format('0,0.00')
                  }
                </strong></div>
              ),
              getFooterProps: () => ({ style: { textAlign: 'right' } }),
              Footer: ({ data }) => (
                <span><strong>
                  {
                    numeral(data.reduce((prev, curr) => prev + numeral(totalizeAportes(curr)).value(), 0)).format('0,0.00')
                  }
                </strong></span>
              )
            }
          ]
        },
        {
          Header: 'Resultados Acumulados',
          columns: [
            {
              Header: 'Reserva Legal',
              accessor: "reservaLegal",
              Cell: renderEditable(),
              getFooterProps: () => ({ style: { textAlign: 'right' } }),
              Footer: (
                <span><strong>
                  {
                    numeral(data.reduce((prev, curr) => prev + numeral(curr.reservaLegal).value(), 0)).format('0,0.00')
                  }
                </strong></span>
              )
            },
            {
              Header: 'Reserva Especial Art. 42',
              accessor: "reservaEspecial",
              Cell: renderEditable(),
              getFooterProps: () => ({ style: { textAlign: 'right' } }),
              Footer: (
                <span><strong>
                  {
                    numeral(data.reduce((prev, curr) => prev + numeral(curr.reservaEspecial).value(), 0)).format('0,0.00')
                  }
                </strong></span>
              )
            },
            {
              Header: 'Resultados No Asignados',
              accessor: "resultadosNoAsignados",
              Cell: renderEditable(),
              getFooterProps: () => ({ style: { textAlign: 'right' } }),
              Footer: (
                <span><strong>
                  {
                    numeral(data.reduce((prev, curr) => prev + numeral(curr.resultadosNoAsignados).value(), 0)).format('0,0.00')
                  }
                </strong></span>
              )
            }
          ]
        },
        {
          Header: 'Totales',
          columns: [
            {
              Header: `${eeconomico ? moment(eeconomico.fechaFin).format('DD/MM/YYYY') : '---'}`,
              Cell: (props) => (
                <div style={{ textAlign: 'right' }}><strong>
                  {
                    numeral(
                      (
                        numeral(props.row.capitalSocial).value() +
                        numeral(props.row.ajusteCapital).value() +
                        numeral(props.row.reservaLegal).value() +
                        numeral(props.row.reservaEspecial).value() +
                        numeral(props.row.resultadosNoAsignados).value()
                      ).toFixed(2)
                    ).format('0,0.00')
                  }
                </strong></div>
              ),
              getFooterProps: () => ({ style: { textAlign: 'right' } }),
              Footer: ({ data }) => (
                <span><strong>
                  {
                    numeral(data.reduce((prev, curr) => prev + numeral(totalizeRow(curr)).value(), 0)).format('0,0.00')
                  }
                </strong></span>
              )
            },
            {
              Header: `${eeconomico ? moment(eeconomico.fechaInicio).format('DD/MM/YYYY') : '---'}`,
              Cell: (props) => (
                <div style={{ textAlign: 'right' }}>
                  {
                    prevEeconomico ?
                      (
                        numeral(prevEeconomico.estadoEvolucionPatrimonio.matrix[props.row._index].capitalSocial).value() +
                        numeral(prevEeconomico.estadoEvolucionPatrimonio.matrix[props.row._index].ajusteCapital).value() +
                        numeral(prevEeconomico.estadoEvolucionPatrimonio.matrix[props.row._index].reservaLegal).value() +
                        numeral(prevEeconomico.estadoEvolucionPatrimonio.matrix[props.row._index].reservaEspecial).value() +
                        numeral(prevEeconomico.estadoEvolucionPatrimonio.matrix[props.row._index].resultadosNoAsignados).value()
                      ).toFixed(2) : '---'
                  }
                </div>
              ),
              getFooterProps: () => ({ style: { textAlign: 'right' } }),
              Footer: ({ data }) => (
                <span><strong>
                  {
                    prevEeconomico ?
                      numeral(
                        prevEeconomico.estadoEvolucionPatrimonio.matrix.reduce((prev, curr) => prev + numeral(totalizeRow(curr)).value(), 0)
                      ).format('0,0.00') : '---'
                  }
                </strong></span>
              )
            }
          ]
        }
      ]}
      defaultPageSize={17}
      className="-striped -highlight" />
    <Segment clearing vertical>
      <Statistic size="mini">
        <Statistic.Label>Patrimonio Neto</Statistic.Label>
        <Statistic.Value>
          {
            eeconomico ?
              numeral(
                (
                  numeral(
                    sumStringsToFloats(
                      sumStringsToFloats(
                        eeconomico.estadoSituacionPatrimonial.cajaBancos,
                        eeconomico.estadoSituacionPatrimonial.creditosAC,
                        eeconomico.estadoSituacionPatrimonial.bienesCambioAC
                      ),
                      sumStringsToFloats(
                        eeconomico.estadoSituacionPatrimonial.creditosANC,
                        eeconomico.estadoSituacionPatrimonial.bienesCambioANC,
                        eeconomico.estadoSituacionPatrimonial.bienesUsoANC
                      )
                    )
                  ).value() - numeral(sumStringsToFloats(eeconomico.estadoSituacionPatrimonial.deudasPC, eeconomico.estadoSituacionPatrimonial.deudasPNC)).value()
                ).toFixed(2)
              ).format('0,0.00') : '---'
          }
        </Statistic.Value>
      </Statistic>
      <Button floated="right" disabled={loading} content={loading ? 'Guardando...' : 'Guardar'} positive onClick={submitValues} />
    </Segment>
  </div>
);

function totalizeAportes (row) {
  return (
    numeral(row.capitalSocial).value() +
    numeral(row.ajusteCapital).value()
  ).toFixed(2);
}

function totalizeRow (row) {
  return (
    numeral(row.capitalSocial).value() +
    numeral(row.ajusteCapital).value() +
    numeral(row.reservaLegal).value() +
    numeral(row.reservaEspecial).value() +
    numeral(row.resultadosNoAsignados).value()
  ).toFixed(2);
}

const EstadoResultados = ({ loading, eeconomico, prevEeconomico, estadoResultados, createInputHandler, VolumenVentaService, PersonalService, submitValues }) => (
  <div>
    <Table basic="very" celled compact columns={3}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell />
          <Table.HeaderCell>Actual</Table.HeaderCell>
          <Table.HeaderCell>Anterior</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Ingresos por Ventas</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={estadoResultados.ingresosVentas} onChange={createInputHandler('ingresosVentas')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.ingresosVentas).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Costo de Ventas (anexo II)</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={estadoResultados.costoVentas} onChange={createInputHandler('costoVentas')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.costoVentas).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>
            Excedente Bruto
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(
                sumStringsToFloats(
                  estadoResultados.ingresosVentas,
                  estadoResultados.costoVentas
                )
              ).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(
                  sumStringsToFloats(
                    prevEeconomico.estadoResultados.ingresosVentas,
                    prevEeconomico.estadoResultados.costoVentas
                  )
                ).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Egresos Comercializacion (Anexo III)</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={estadoResultados.egresosComercializacion} onChange={createInputHandler('egresosComercializacion')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.egresosComercializacion).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Egresos Administracion (Anexo III)</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={estadoResultados.egresosAdministracion} onChange={createInputHandler('egresosAdministracion')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.egresosAdministracion).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Egresos Financieros (Anexo III)</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={estadoResultados.egresosFinancieros} onChange={createInputHandler('egresosFinancieros')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.egresosFinancieros).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Egresos Fiscales (Anexo III)</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={estadoResultados.egresosFiscales} onChange={createInputHandler('egresosFiscales')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.egresosFiscales).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Egresos Generales (Anexo III)</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={estadoResultados.egresosGenerales} onChange={createInputHandler('egresosGenerales')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.egresosGenerales).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>
            Excedente Operativo
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(
                sumStringsToFloats(
                  estadoResultados.ingresosVentas,
                  estadoResultados.costoVentas,
                  estadoResultados.egresosComercializacion,
                  estadoResultados.egresosAdministracion,
                  estadoResultados.egresosFinancieros,
                  estadoResultados.egresosFiscales,
                  estadoResultados.egresosGenerales
                )
              ).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(
                  sumStringsToFloats(
                    prevEeconomico.estadoResultados.ingresosVentas,
                    prevEeconomico.estadoResultados.costoVentas,
                    prevEeconomico.estadoResultados.egresosComercializacion,
                    prevEeconomico.estadoResultados.egresosAdministracion,
                    prevEeconomico.estadoResultados.egresosFinancieros,
                    prevEeconomico.estadoResultados.egresosFiscales,
                    prevEeconomico.estadoResultados.egresosGenerales
                  )
                ).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Ingresos Indirectamente atribuidos</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={estadoResultados.ingresosIndirectamenteAtribuidos} onChange={createInputHandler('ingresosIndirectamenteAtribuidos')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.ingresosIndirectamenteAtribuidos).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Gastos Indirectamente atribuidos</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={estadoResultados.gastosIndirectamenteAtribuidos} onChange={createInputHandler('gastosIndirectamenteAtribuidos')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.gastosIndirectamenteAtribuidos).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Ingresos Extraordinarios</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={estadoResultados.ingresosExtraordinarios} onChange={createInputHandler('ingresosExtraordinarios')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.ingresosExtraordinarios).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>
            Excedente neto del ejercicio
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(
                sumStringsToFloats(
                  estadoResultados.ingresosVentas,
                  estadoResultados.costoVentas,
                  estadoResultados.egresosComercializacion,
                  estadoResultados.egresosAdministracion,
                  estadoResultados.egresosFinancieros,
                  estadoResultados.egresosFiscales,
                  estadoResultados.egresosGenerales,
                  estadoResultados.ingresosIndirectamenteAtribuidos,
                  estadoResultados.gastosIndirectamenteAtribuidos,
                  estadoResultados.ingresosExtraordinarios
                )
              ).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(
                  sumStringsToFloats(
                    prevEeconomico.estadoResultados.ingresosVentas,
                    prevEeconomico.estadoResultados.costoVentas,
                    prevEeconomico.estadoResultados.egresosComercializacion,
                    prevEeconomico.estadoResultados.egresosAdministracion,
                    prevEeconomico.estadoResultados.egresosFinancieros,
                    prevEeconomico.estadoResultados.egresosFiscales,
                    prevEeconomico.estadoResultados.egresosGenerales,
                    prevEeconomico.estadoResultados.ingresosIndirectamenteAtribuidos,
                    prevEeconomico.estadoResultados.gastosIndirectamenteAtribuidos,
                    prevEeconomico.estadoResultados.ingresosExtraordinarios
                  )
                ).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Resultado por la gestion cooperativa con Asociados</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={estadoResultados.resultadoGestionAsociados} onChange={createInputHandler('resultadoGestionAsociados')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.resultadoGestionAsociados).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Resultado por la gestion cooperativa con No Asociados</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={estadoResultados.resultadoGestionNoAsociados} onChange={createInputHandler('resultadoGestionNoAsociados')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.resultadoGestionNoAsociados).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Resultado por operaciones ajenas a la gestion cooperativa</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={estadoResultados.resultadoOperacionesAjenas} onChange={createInputHandler('resultadoOperacionesAjenas')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.resultadoOperacionesAjenas).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>
            Excedente Neto del ejercicio
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(
                sumStringsToFloats(
                  estadoResultados.resultadoGestionAsociados,
                  estadoResultados.resultadoGestionNoAsociados,
                  estadoResultados.resultadoOperacionesAjenas
                )
              ).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(
                  sumStringsToFloats(
                    prevEeconomico.estadoResultados.resultadoGestionAsociados,
                    prevEeconomico.estadoResultados.resultadoGestionNoAsociados,
                    prevEeconomico.estadoResultados.resultadoOperacionesAjenas
                  )
                ).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
      </Table.Body>
    </Table>
    <Segment clearing vertical>
      <Button floated="right" disabled={loading} content={loading ? 'Guardando...' : 'Guardar'} positive onClick={submitValues} />
    </Segment>
    <Header as="h5" content="Volumenes de Venta" dividing />
    <ATable
      pageRange={PAGE_RANGE}
      headers={{
        'Concepto': ['concepto'],
        'Unidad': ['unidad'],
        'M. Interno': ['minterno'],
        'M. Externo': ['mexterno']
      }}
      service={VolumenVentaService}
      options={{
        serviceParams: {
          EstadoResultadosId: estadoResultados.id,
          test: console.log(estadoResultados.id)
        }
      }}
      form={{
        fields: [
          ['!Concepto', 'concepto', 'input', 5],
          ['!Unidad', 'unidad', 'input', 5],
          ['!M. Interno', 'minterno', 'number', 5],
          ['!M. Externo', 'mexterno', 'number', 5]
        ],
        service: VolumenVentaService,
        options: {
          serviceParams: {
            EstadoResultadosId: estadoResultados.id
          }
        }
      }} />
    <Header as="h5" content="Personal" dividing />
    <ATable
      pageRange={PAGE_RANGE}
      headers={{
        'Concepto': ['concepto'],
        'Unidad': ['unidad'],
        'Cantidad': ['cantidad'],
        'Tiempo': ['tiempo'],
        'Remuneracion': ['remuneracion']
      }}
      service={PersonalService}
      options={{
        serviceParams: {
          EstadoResultadosId: estadoResultados.id
        }
      }}
      form={{
        fields: [
          ['!Concepto', 'concepto', 'input', 5],
          ['!Unidad', 'unidad', 'input', 5],
          ['!Cantidad', 'cantidad', 'number', 5],
          ['!Tiempo', 'tiempo', 'number', 5],
          ['!Remuneracion', 'remuneracion', 'number', 5]
        ],
        service: PersonalService,
        options: {
          serviceParams: {
            EstadoResultadosId: estadoResultados.id
          }
        }
      }} />
  </div>
);

const PropuestaAplicacionDistribucionExcedentes = ({ loading, prevEeconomico, eeconomico, propuestaAplicacionDistribucion, createInputHandler, submitValues }) => (
  <div>
    <Statistic size="mini">
      <Statistic.Label>Estado de Resultados - Excedente Neto del Ejercicio</Statistic.Label>
      <Statistic.Value>{
        eeconomico ?
          numeral(
            sumStringsToFloats(
              eeconomico.estadoResultados.ingresosVentas,
              eeconomico.estadoResultados.costoVentas,
              eeconomico.estadoResultados.egresosComercializacion,
              eeconomico.estadoResultados.egresosAdministracion,
              eeconomico.estadoResultados.egresosFinancieros,
              eeconomico.estadoResultados.egresosFiscales,
              eeconomico.estadoResultados.egresosGenerales,
              eeconomico.estadoResultados.ingresosIndirectamenteAtribuidos,
              eeconomico.estadoResultados.gastosIndirectamenteAtribuidos,
              eeconomico.estadoResultados.ingresosExtraordinarios
            )
          ).format('0,0.00') : '---'
      }</Statistic.Value>
    </Statistic>
    <Table basic="very" compact celled columns={3}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell />
          <Table.HeaderCell>Actual</Table.HeaderCell>
          <Table.HeaderCell>Anterior</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Excedentes del Ejercicio</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={propuestaAplicacionDistribucion.excedenteEjercicio} onChange={createInputHandler('excedenteEjercicio')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.excedenteEjercicio).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Resultado por la gestion cooperativa con No Asociados</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={propuestaAplicacionDistribucion.resultadoGestionNoAsociados} onChange={createInputHandler('resultadoGestionNoAsociados')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.resultadoGestionNoAsociados).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Resultado por operaciones ajenas a la gestion cooperativa</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={propuestaAplicacionDistribucion.resultadoOperacionesAjenas} onChange={createInputHandler('resultadoOperacionesAjenas')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.resultadoOperacionesAjenas).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>Resultado Neto por la gestion cooperativa con Asociados</Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(
                sumStringsToFloats(
                  propuestaAplicacionDistribucion.excedenteEjercicio,
                  propuestaAplicacionDistribucion.resultadoGestionNoAsociados,
                  propuestaAplicacionDistribucion.resultadoOperacionesAjenas
                )
              ).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(
                  sumStringsToFloats(
                    prevEeconomico.propuestaAplicacionDistribucion.excedenteEjercicio,
                    prevEeconomico.propuestaAplicacionDistribucion.resultadoGestionNoAsociados,
                    prevEeconomico.propuestaAplicacionDistribucion.resultadoOperacionesAjenas
                  )
                ).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Reserva Legal</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={propuestaAplicacionDistribucion.reservaLegal} onChange={createInputHandler('reservaLegal')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.reservaLegal).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Reserva Art 42</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={propuestaAplicacionDistribucion.reservaArt42} onChange={createInputHandler('reservaArt42')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.reservaArt42).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Fondo para Estimulo del Personal</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={propuestaAplicacionDistribucion.fondoEstimulo} onChange={createInputHandler('fondoEstimulo')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.fondoEstimulo).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Fondo para Educacion y Capacitacion Cooperativa</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={propuestaAplicacionDistribucion.fondoEducacionCapacitacion} onChange={createInputHandler('fondoEducacionCapacitacion')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.fondoEducacionCapacitacion).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>Excedentes repartibles</Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(
                sumStringsToFloats(
                  propuestaAplicacionDistribucion.excedenteEjercicio,
                  propuestaAplicacionDistribucion.resultadoGestionNoAsociados,
                  propuestaAplicacionDistribucion.resultadoOperacionesAjenas,
                  propuestaAplicacionDistribucion.reservaLegal,
                  propuestaAplicacionDistribucion.reservaArt42,
                  propuestaAplicacionDistribucion.fondoEstimulo,
                  propuestaAplicacionDistribucion.fondoEducacionCapacitacion
                )
              ).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(
                  sumStringsToFloats(
                    prevEeconomico.propuestaAplicacionDistribucion.excedenteEjercicio,
                    prevEeconomico.propuestaAplicacionDistribucion.resultadoGestionNoAsociados,
                    prevEeconomico.propuestaAplicacionDistribucion.resultadoOperacionesAjenas,
                    prevEeconomico.propuestaAplicacionDistribucion.reservaLegal,
                    prevEeconomico.propuestaAplicacionDistribucion.reservaArt42,
                    prevEeconomico.propuestaAplicacionDistribucion.fondoEstimulo,
                    prevEeconomico.propuestaAplicacionDistribucion.fondoEducacionCapacitacion
                  )
                ).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Intereses a pagar en efectivo</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={propuestaAplicacionDistribucion.interesesAPagar} onChange={createInputHandler('interesesAPagar')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.interesesAPagar).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Excedentes en cuotas sociales</Table.Cell>
          <Table.Cell>
            <Form.Input
              className="accounting-table-input" fluid size="mini"
              children={
                <MaskedInput mask={numberMask} value={propuestaAplicacionDistribucion.excedentesCuotaSocial} onChange={createInputHandler('excedentesCuotaSocial')} />
              } />
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.excedentesCuotaSocial).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
    <Segment clearing vertical>
      <Button floated="right" disabled={loading} content={loading ? 'Guardando...' : 'Guardar'} positive onClick={submitValues} />
    </Segment>
  </div>
);


// WEBPACK FOOTER //
// ./client/components/pages/cooperativas/CoopEEconomicoDetalleView.js